import { useParams } from "react-router";
import { MetadataDashboardTemplate } from "../../../components/Templates/MetadataDashboardTemplate";

export default function SingleSubjectDeviations() {
  const { subjectId } = useParams<{ subjectId: string }>();
  return (
    <MetadataDashboardTemplate
      type="protocol_deviations_subjects"
      subjectId={subjectId}
      constants={{
        wikiLink: "/wiki/guides/exploration-singlesubject-deviations",
        idLink: undefined,
      }}
    />
  );
}
